<div class="form-dialog">
  <h1>{{title}}
  </h1>
  <mat-dialog-content>
    <mat-tab-group [disableRipple]="true">
      <mat-tab label="Configuration">
        <form class="form-section column space-between">

          <div class="row full-height">
            <mat-form-field>
              <mat-label>Calendar</mat-label>
              <mat-select [(ngModel)]="defaultDtp.calendar" name="calendar" (ngModelChange)="markDirty()">
                @for (calendar of calendars; track calendar) {
                  @if (calendar.account_id === appScope.active_account_id || calendar.name === dateTimePeriodService.defaultCalendar) {
                    <mat-option
                        [value]="calendar.name">
                      <span>{{calendar.name | removeUnderscore | upperfirst}}</span>
                    </mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>

              @if (ranges?.length || rangeGroups?.length) {
                <select-filter
                               [label]="'Range'"
                               (constant_changed)="defaultDtp.range=$event; markDirty()"
                               [modelValue]="defaultDtp.range"
                               [classes]="'fill'"
                               [options]="ranges"
                               [groupedOptions]="rangeGroups" class="select-search">
                </select-filter>
              }
              <div class="mat-hint">The default date range for data on this page.</div>

              @if (samplePeriods?.length || samplePeriodGroups?.length) {
                <select-filter
                               [label]="'Sample Period'"
                               (constant_changed)="defaultDtp.sample_period=$event; markDirty()"
                               [modelValue]="defaultDtp.sample_period"
                               [classes]="'fill'"
                               [options]="samplePeriods"
                               [groupedOptions]="samplePeriodGroups" class="select-search">
                </select-filter>
              }
              <div class="mat-hint">The default sample period for data on this page.</div>


          </div>

        </form>
      </mat-tab>


    </mat-tab-group>

  </mat-dialog-content>
  <div class="action-buttons">
    <button (click)="onCloseClick()" class="btn-close">Close</button>
    <button (click)="save()" class="btn-save">Save</button>
  </div>
</div>
